// PropertiesIndex

import PropertiesScreen from "@/screens/analyze/PropertiesScreen"
import { useIsDesktop } from "@/hooks/useIsDesktop"

export default function PropertiesIndex() {
  const isDesktop = useIsDesktop()
  return isDesktop ? null : <PropertiesScreen />
}
